import { Link } from "react-router-dom";
import { ArrowRight, BookOpen, Sparkles } from "lucide-react";

const themeBg = {
    Kindness: "bg-sun",
    Courage: "bg-coral",
    Forgiveness: "bg-lilac",
    Gratitude: "bg-mint",
    Honesty: "bg-sky",
    Generosity: "bg-sun",
    Patience: "bg-lilac",
    Friendship: "bg-mint",
    Hope: "bg-sky",
};

function ageColor(age) {
    if (age === "5-8") return "bg-mint text-ink";
    if (age === "9-12") return "bg-coral text-white";
    return "bg-sky text-white";
}

export default function LessonCard({ lesson, featured = false }) {
    if (!lesson) return null;
    const bg = themeBg[lesson.theme] || "bg-sun";

    return (
        <Link
            to={`/lessons/${lesson.id}`}
            data-testid={`lesson-card-${lesson.id}`}
            className={`group block card-sticker overflow-hidden transition-all hover:shadow-sticker-lg hover:-translate-x-[2px] hover:-translate-y-[2px] ${
                featured ? "p-0" : "p-0"
            }`}
        >
            <div className={`${bg} border-b-2 border-ink p-6 relative`}>
                <div className="flex items-center justify-between mb-3">
                    <span className="pill bg-white">
                        <BookOpen className="w-3 h-3" strokeWidth={2.5} /> {lesson.theme}
                    </span>
                    <span className="font-accent text-xl text-ink/80">{lesson.date}</span>
                </div>
                <h3 className="font-heading text-2xl sm:text-3xl font-bold leading-tight tracking-tight pr-2">
                    {lesson.title}
                </h3>
                <Sparkles className="absolute -top-3 -right-3 w-10 h-10 text-ink bg-white rounded-full p-1.5 border-2 border-ink shadow-sticker-sm rotate-12" strokeWidth={2.5} />
            </div>

            <div className="p-6 bg-white">
                <p className="text-sm font-semibold uppercase tracking-widest text-ink/60 mb-1">
                    {lesson.bible_reference}
                </p>
                <p className="text-base leading-relaxed text-ink/80 line-clamp-3">
                    {lesson.story_summary}
                </p>

                <div className="flex flex-wrap gap-2 mt-5">
                    {(lesson.age_groups || []).map((a) => (
                        <span key={a} className={`pill ${ageColor(a)}`}>Ages {a}</span>
                    ))}
                </div>

                <div className="mt-5 flex items-center justify-between">
                    <span className="font-heading font-semibold text-sm text-ink">
                        Read lesson
                    </span>
                    <ArrowRight
                        className="w-5 h-5 group-hover:translate-x-1 transition-transform"
                        strokeWidth={2.5}
                    />
                </div>
            </div>
        </Link>
    );
}
